import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Thin axios wrapper kept only for the legacy /connection debug page.
// New code goes through lib/shopify/queries.js instead.
export const api = axios.create({ baseURL: API, timeout: 20000 });

export async function fetchShopifyHealth() {
  const { data } = await api.get("/shopify/health");
  return data;
}

export async function fetchShopifyProducts({ first = 20, after = null } = {}) {
  const params = { first };
  if (after) params.after = after;
  const { data } = await api.get("/shopify/products", { params });
  return data;
}
